document.addEventListener('DOMContentLoaded', function () {
  var box = document.querySelector('.ldm-home-links');
  if (!box) return;

  var heading = box.querySelector('h2');
  if (heading && heading.textContent.trim() === 'Everything You Need to Feed With Confidence') {
    heading.textContent = 'Practical Help for the Dog in Front of You';
  }

  var directParagraphs = Array.prototype.filter.call(box.children, function (el) {
    return el.tagName === 'P';
  });

  var intro = directParagraphs[0];
  if (intro && intro.textContent.replace(/\s+/g, ' ').trim().indexOf('Practical books, tools, resources, and real-food treats') === 0) {
    intro.textContent = 'Books, workbooks, calculators, resources, and thoughtfully made treats for real life with dogs—from health conditions and nutrition to everyday care.';
  }

  var items = box.querySelectorAll('.ldm-home-grid > div');
  Array.prototype.forEach.call(items, function (item) {
    var link = item.querySelector('a');
    var detail = item.querySelector('span');
    if (!link || !detail) return;

    var label = link.textContent.trim();
    if (label === 'Books & Guides') {
      detail.textContent = 'Health conditions, nutrition, feeding, and everyday dog care.';
    } else if (label === 'Resources') {
      detail.textContent = 'Workbooks, worksheets, trackers, and companion materials.';
    } else if (label === 'Treats') {
      detail.textContent = 'Simple real-food treats made with intention.';
    }
  });

  var closing = directParagraphs[directParagraphs.length - 1];
  if (closing && closing.textContent.indexOf('Feed with intention') !== -1) {
    closing.innerHTML = 'Understand more. Ask better questions. <strong>Make informed choices.</strong>';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!match || document.querySelector('.ldm-context-bar--books')) return;

  var handle = match[1];

  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function (response) {
      if (!response.ok) throw new Error('Unable to load product');
      return response.json();
    })
    .then(function (product) {
      if (!product || String(product.type || '').toLowerCase() !== 'book') return;
      if (document.querySelector('.ldm-context-bar--books')) return;

      var style = document.getElementById('ldm-book-context-styles');
      if (!style) {
        style = document.createElement('style');
        style.id = 'ldm-book-context-styles';
        style.textContent =
          '.ldm-context-bar--books{background:#fff;border-bottom:1px solid rgba(79,96,68,.16);}' +
          '.ldm-book-context-nav{max-width:1200px;margin:0 auto;min-height:46px;padding:0 24px;display:flex;align-items:stretch;overflow-x:auto;scrollbar-width:none;}' +
          '.ldm-book-context-nav::-webkit-scrollbar{display:none;}' +
          '.ldm-book-context-title{display:flex;align-items:center;flex:0 0 auto;color:#292B27!important;font-size:2.2rem;font-weight:500;line-height:1;text-decoration:none!important;padding:0 30px 0 0;margin-right:14px;white-space:nowrap;}' +
          '.ldm-book-context-links{display:flex;align-items:stretch;flex:0 0 auto;}' +
          '.ldm-book-context-link{display:flex;align-items:center;flex:0 0 auto;color:#4F6044!important;font-size:1.3rem;font-weight:500;text-decoration:none!important;padding:0 16px;white-space:nowrap;}' +
          '.ldm-book-context-link:hover,.ldm-book-context-title:hover{color:#C96545!important;}' +
          '.ldm-book-context-link.is-current{font-weight:750;color:#292B27!important;}' +
          '@media(max-width:749px){.ldm-book-context-nav{min-height:43px;padding:0 16px}.ldm-book-context-title{font-size:1.8rem;padding-right:18px;margin-right:6px}.ldm-book-context-link{font-size:1.18rem;padding:0 11px}}';
        document.head.appendChild(style);
      }

      var bar = document.createElement('div');
      bar.className = 'ldm-context-bar--books';

      var isSurvival = Array.isArray(product.tags) && product.tags.some(function (tag) {
        return String(tag).toLowerCase() === 'dog parent survival guide';
      });

      bar.innerHTML =
        '<nav class="ldm-book-context-nav" aria-label="Book navigation">' +
          '<a class="ldm-book-context-title" href="/collections/main-menu-books">Books</a>' +
          '<div class="ldm-book-context-links">' +
            '<a class="ldm-book-context-link" href="/collections/main-menu-books">Shop Books</a>' +
            '<a class="ldm-book-context-link' + (isSurvival ? ' is-current' : '') + '" href="/collections/survival-guides">Survival Guides</a>' +
            '<a class="ldm-book-context-link" href="/collections/fresh-feeding-books">Fresh Feeding</a>' +
            '<a class="ldm-book-context-link" href="/collections/main-menu-guides">Guides &amp; Workbooks</a>' +
          '</div>' +
        '</nav>';

      var stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        stickyHeader.insertAdjacentElement('afterend', bar);
        return;
      }

      var header = document.querySelector('header.header');
      if (header) header.insertAdjacentElement('afterend', bar);
    })
    .catch(function () {
      /* Leave the storefront unchanged if product metadata can't be loaded. */
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('a');
  Array.prototype.forEach.call(links, function (link) {
    var href = link.getAttribute('href') || '';
    if (link.textContent.trim() === 'Shop All' && href.indexOf('/collections/all-treats') !== -1) {
      link.setAttribute('href', '/collections/all');
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var explainers = document.querySelectorAll('.ldm-raw__bottom details, .ldm-cal__bottom details');
  if (!explainers.length) return;

  var style = document.getElementById('ldm-always-visible-explainer-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'ldm-always-visible-explainer-styles';
    style.textContent =
      '.ldm-raw__bottom .ldm-bottom-explainer__title,.ldm-cal__bottom .ldm-bottom-explainer__title{display:block;font-weight:800;color:#4F6044;}' +
      '.ldm-bottom-explainer{cursor:default;}';
    document.head.appendChild(style);
  }

  Array.prototype.forEach.call(explainers, function (details) {
    var summary = details.querySelector('summary');
    var replacement = document.createElement('div');
    replacement.className = 'ldm-bottom-explainer';

    if (summary) {
      var title = document.createElement('strong');
      title.className = 'ldm-bottom-explainer__title';
      title.textContent = summary.textContent.trim();
      replacement.appendChild(title);
    }

    Array.prototype.slice.call(details.children).forEach(function (child) {
      if (child !== summary) replacement.appendChild(child);
    });

    details.replaceWith(replacement);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var style = document.getElementById('ldm-compact-calculator-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'ldm-compact-calculator-styles';
    style.textContent = `
      .ldm-cal,.ldm-raw{padding:3.2rem 0!important}
      .ldm-cal__wrap,.ldm-raw__wrap{max-width:980px!important}
      .ldm-cal__hero,.ldm-raw__hero{max-width:740px!important;margin-bottom:2rem!important}
      .ldm-cal__hero h1,.ldm-raw__hero h1{font-size:clamp(2.7rem,4vw,4.2rem)!important;margin:.45rem 0 .75rem!important}
      .ldm-cal__intro,.ldm-raw__intro{font-size:1.5rem!important}
      .ldm-cal__privacy,.ldm-raw__privacy{padding:.55rem 1rem!important;font-size:1.1rem!important}
      .ldm-cal__card,.ldm-raw__card{border-radius:18px!important;padding:clamp(1.7rem,3vw,2.6rem)!important;margin-bottom:1.7rem!important;box-shadow:0 10px 28px rgba(41,43,39,.055)!important}
      .ldm-cal__step,.ldm-raw__step{gap:1rem!important;margin-bottom:1.55rem!important}
      .ldm-cal__step>b,.ldm-raw__step>b{min-width:3rem!important;width:3rem!important;height:3rem!important;font-size:1.35rem!important}
      .ldm-cal__step h2,.ldm-raw__step h2{font-size:clamp(1.9rem,2.6vw,2.45rem)!important}
      .fieldbox input,.fieldbox select,.raw-fieldbox input,.raw-fieldbox select{min-height:4.4rem!important;padding:.8rem 1rem!important;border-radius:10px!important}
      .ldm-cal__fields,.ldm-raw__fields{gap:1rem!important}
      .choicegroups{gap:1rem!important;margin:1.55rem 0!important}
      .choicegrid{gap:.55rem!important}
      .choicegrid span{min-height:3.7rem!important;padding:.65rem 1rem!important}
      .choicegrid.status span{min-width:16rem!important}.choicegrid.activity span{min-width:10.5rem!important}.choicegrid.body span{min-width:10rem!important}
      .choicegrid input:checked+span{padding:calc(.65rem - 1px) calc(1rem - 1px)!important}
      .labelhelp{padding:1.05rem 1.15rem!important;margin-bottom:1.4rem!important;border-radius:12px!important}
      .ldm-cal__results{margin-top:1.8rem!important;padding-top:1.6rem!important}
      .resultgrid>div{padding:1.15rem!important;border-radius:12px!important}.resultgrid strong{font-size:clamp(2.25rem,3.4vw,3.2rem)!important}
      .ldm-cal__foodresult{margin-top:1.5rem!important;padding:1.25rem!important;border-radius:13px!important}.ldm-cal__foodresult>div{padding:1rem!important}.ldm-cal__foodresult strong{font-size:1.9rem!important}
      .ldm-cal__bottom,.ldm-raw__bottom{gap:.9rem!important}.ldm-cal__bottom>*,.ldm-raw__bottom>*{padding:1.15rem!important;border-radius:12px!important}
      .raw-modelgrid{gap:.75rem!important}.raw-modelgrid span{padding:1.1rem!important;border-radius:12px!important}.raw-modelgrid input:checked+span{padding:calc(1.1rem - 1px)!important}.raw-modelgrid strong{font-size:1.55rem!important}
      .raw-modelnote{margin-top:.75rem!important;padding:.9rem 1.05rem!important}.raw-groups{gap:1rem!important;margin:1.5rem 0!important}.raw-pillgrid{gap:.55rem!important}
      .raw-pillgrid span{min-height:3.7rem!important;min-width:8.7rem!important;padding:.6rem .9rem!important}.raw-pillgrid input:checked+span{padding:calc(.6rem - 1px) calc(.9rem - 1px)!important}
      .raw-percent-panel{padding:1.1rem!important;margin-bottom:1.2rem!important;border-radius:13px!important}.raw-resultgrid{gap:.75rem!important}.raw-resultgrid>div{padding:1.15rem!important;border-radius:12px!important}.raw-resultgrid strong{font-size:clamp(2rem,2.7vw,2.7rem)!important}.raw-balance-note{margin-top:1rem!important;padding:1rem!important;border-radius:12px!important}

      .batch-prep-calculator-section.ldm-batch-upgraded{max-width:980px!important;margin:1.8rem auto 3rem!important;color:#292B27}
      .ldm-batch-upgraded .batch-prep-calculator-card{background:#fff!important;border:1px solid #dfe3da!important;border-radius:18px!important;padding:2.4rem!important;box-shadow:0 10px 28px rgba(41,43,39,.055)!important}
      .ldm-batch-upgraded .batch-prep-calculator-title{margin:0 0 .45rem!important;font-size:clamp(2rem,2.8vw,2.65rem)!important;line-height:1.15}
      .ldm-batch-upgraded .batch-prep-calculator-title:before{content:'BATCH PREP TOOL';display:block;color:#C96545;font-size:1.05rem;letter-spacing:.12em;font-weight:800;margin-bottom:.45rem}
      .ldm-batch-upgraded .batch-prep-calculator-text{color:#666;margin-bottom:1.5rem!important}
      .ldm-batch-upgraded .batch-prep-calculator-form{display:grid!important;grid-template-columns:1fr 1fr;gap:1.35rem!important}
      .ldm-batch-upgraded .batch-prep-calculator-field:nth-child(3),.ldm-batch-upgraded .batch-prep-calculator-button-row{grid-column:1/-1}
      .ldm-batch-upgraded .batch-prep-calculator-field>label{color:#292B27;font-weight:800!important;margin-bottom:.55rem!important}
      .ldm-batch-upgraded .batch-prep-calculator-field input{min-height:4.4rem;border:1px solid #cdd1ca!important;border-radius:10px!important;padding:.8rem 1rem!important;background:#fff!important;color:#292B27!important}
      .ldm-batch-upgraded .batch-prep-calculator-field select{display:none!important}
      .ldm-batch-choicegrid{display:flex;flex-wrap:wrap;gap:.55rem}.ldm-batch-choice{position:relative;cursor:pointer}.ldm-batch-choice input{position:absolute;opacity:0;pointer-events:none}
      .ldm-batch-choice span{display:flex;align-items:center;justify-content:center;min-height:3.8rem;min-width:10rem;padding:.65rem 1rem;border:1px solid #d4d8d0;border-radius:10px;background:#FBFAF7;font-weight:700;text-align:center}
      .ldm-batch-choice input:checked+span{border:2px solid #4F6044;background:#eef2eb;padding:calc(.65rem - 1px) calc(1rem - 1px)}
      .ldm-batch-choice input:focus-visible+span{outline:3px solid rgba(79,96,68,.28);outline-offset:2px}
      .ldm-batch-upgraded .batch-prep-calculator-note{margin-top:.5rem!important;color:#6b6b6b;opacity:1!important}
      .ldm-batch-upgraded .batch-prep-calculator-inline-fields{gap:.8rem!important}.ldm-batch-upgraded .batch-inline-label{color:#666;font-size:1.15rem!important;font-weight:700!important}
      .ldm-batch-upgraded .batch-prep-calculator-button-row{gap:.75rem!important;margin-top:.1rem}.ldm-batch-upgraded .button{min-height:4.2rem;padding:.8rem 1.7rem}.ldm-batch-upgraded .button--primary{background:#4F6044!important;color:#fff!important;border-color:#4F6044!important}
      .ldm-batch-upgraded .batch-prep-calculator-results{margin-top:1.8rem!important;padding-top:1.6rem!important;border-top:1px solid #e2e4df!important}.ldm-batch-upgraded .batch-prep-calculator-results h3{margin:0 0 1rem;font-size:2rem}
      .ldm-batch-upgraded .batch-prep-calculator-summary{display:flex;flex-wrap:wrap;gap:.55rem;margin-bottom:1rem!important}.ldm-batch-upgraded .batch-prep-calculator-summary p{margin:0!important;padding:.5rem .8rem;border-radius:999px;background:#f2f2ee;font-size:1.2rem}.ldm-batch-upgraded .batch-prep-calculator-summary p:last-child{background:#4F6044;color:#fff}
      .ldm-batch-upgraded .batch-prep-calculator-result-grid{grid-template-columns:repeat(3,1fr)!important;gap:.75rem!important;margin-top:.9rem!important}.ldm-batch-upgraded .batch-prep-calculator-result-item{padding:1.1rem!important;border-radius:12px!important;background:#F7F3EA!important}.ldm-batch-upgraded .batch-prep-calculator-result-item .label{font-size:1.2rem!important;color:#666;margin-bottom:.35rem!important}.ldm-batch-upgraded .batch-prep-calculator-result-item .value{font-size:1.75rem!important;color:#292B27}
      .ldm-batch-upgraded .batch-prep-calculator-disclaimer{margin-top:1rem!important;padding:1rem 1.1rem;border-radius:12px;background:#fbf3e3;color:#5d5140;opacity:1!important}.ldm-batch-upgraded .batch-prep-calculator-disclaimer p{margin:0}

      @media(max-width:749px){
        .ldm-cal,.ldm-raw{padding:2.3rem 0!important}.ldm-cal__hero,.ldm-raw__hero{margin-bottom:1.5rem!important}.ldm-cal__card,.ldm-raw__card{padding:1.5rem!important;margin-bottom:1.25rem!important}
        .choicegrid span,.choicegrid.status span,.choicegrid.activity span,.choicegrid.body span,.raw-pillgrid span{min-width:0!important}
        .ldm-batch-upgraded .batch-prep-calculator-card{padding:1.5rem!important}.ldm-batch-upgraded .batch-prep-calculator-form{grid-template-columns:1fr!important;gap:1rem!important}.ldm-batch-upgraded .batch-prep-calculator-field:nth-child(3),.ldm-batch-upgraded .batch-prep-calculator-button-row{grid-column:1}.ldm-batch-upgraded .batch-prep-calculator-result-grid{grid-template-columns:1fr 1fr!important}.ldm-batch-choice{flex:1 1 0}.ldm-batch-choice span{min-width:0;width:100%}
      }
    `;
    document.head.appendChild(style);
  }

  function upgradeBatch(root) {
    if (!root || root.dataset.ldmUpgraded === '1') return;
    root.dataset.ldmUpgraded = '1';
    root.classList.add('ldm-batch-upgraded');

    function convertSelect(select, groupName) {
      if (!select || select.dataset.ldmPills === '1') return;
      select.dataset.ldmPills = '1';
      var grid = document.createElement('div');
      grid.className = 'ldm-batch-choicegrid ldm-batch-choicegrid--' + groupName;

      Array.prototype.forEach.call(select.options, function (option, index) {
        var label = document.createElement('label');
        label.className = 'ldm-batch-choice';
        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'ldm-batch-' + groupName + '-' + (root.id || 'calculator');
        radio.value = option.value;
        radio.checked = option.value === select.value || (!select.value && index === 0);
        var span = document.createElement('span');
        span.textContent = option.textContent;
        label.appendChild(radio);
        label.appendChild(span);
        grid.appendChild(label);

        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          select.value = radio.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      select.insertAdjacentElement('afterend', grid);
      select.addEventListener('change', function () {
        var radios = grid.querySelectorAll('input[type="radio"]');
        Array.prototype.forEach.call(radios, function (radio) {
          radio.checked = radio.value === select.value;
        });
      });
    }

    convertSelect(root.querySelector('select[id^="model-"]'), 'model');
    convertSelect(root.querySelector('select[id^="stage-"]'), 'stage');
  }

  Array.prototype.forEach.call(document.querySelectorAll('.batch-prep-calculator-section'), upgradeBatch);
});

document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[id$="__featured_collection_r6C8EG"]');
  if (!section) return;

  var heading = section.querySelector('.collection__title .title');
  if (heading && heading.textContent.trim() === 'Books') {
    heading.textContent = 'Fresh Food';
  }
});
